/*
  STAGING ONLY
  Ticketing Donut V14:
  - Data mengikuti Rekap Status.
  - Bentuk donut dibuat seperti public: ring tebal, celah putih, warna rapat ke tengah.
  - Tidak mengubah database/API.
*/

(function () {
  const STYLE_ID = "ticketing-donut-public-shape-v14-style";

  const STATUS_ORDER = ["OPEN", "IN PROGRESS", "OVERDUE", "RESOLVED", "CLOSED", "REJECTED"];

  const STATUS_LABEL = {
    OPEN: "Open",
    "IN PROGRESS": "In Progress",
    OVERDUE: "Overdue",
    RESOLVED: "Resolved",
    CLOSED: "Closed",
    REJECTED: "Rejected",
  };

  const STATUS_COLOR = {
    OPEN: "#60a5fa",
    "IN PROGRESS": "#facc15",
    OVERDUE: "#e11d48",
    RESOLVED: "#06b6d4",
    CLOSED: "#22c55e",
    REJECTED: "#fb923c",
  };

  const CATS = [
    { key: "INFRASTRUKTUR", rekap: "INF", title: "INFRASTRUKTUR" },
    { key: "ERP", rekap: "ERP", title: "ERP" },
    { key: "APLIKASI", rekap: "APLIKASI", title: "APLIKASI" },
  ];

  let lastSignature = "";
  let timer = null;

  function cleanText(v) {
    return String(v || "").replace(/\s+/g, " ").trim();
  }

  function normStatus(v) {
    const t = cleanText(v).toUpperCase();

    if (t.includes("IN PROGRESS") || t.includes("PROGRESS")) return "IN PROGRESS";
    if (t.includes("OVERDUE")) return "OVERDUE";
    if (t.includes("RESOLVED")) return "RESOLVED";
    if (t.includes("CLOSED") || t.includes("CLOSE")) return "CLOSED";
    if (t.includes("REJECTED") || t.includes("REJECT")) return "REJECTED";
    if (t.includes("OPEN")) return "OPEN";

    return "";
  }

  function parseNumber(v) {
    const n = parseInt(String(v || "0").replace(/[^\d-]/g, ""), 10);
    return Number.isFinite(n) ? n : 0;
  }

  function injectStyle() {
    if (document.getElementById(STYLE_ID)) return;

    const style = document.createElement("style");
    style.id = STYLE_ID;
    style.textContent = `
      .ticketing-donut-v14-area {
        width: 100% !important;
        min-height: 355px !important;
        height: 355px !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        background: transparent !important;
        border: 0 !important;
        box-shadow: none !important;
        outline: 0 !important;
        padding: 0 !important;
        margin: 0 auto !important;
        overflow: visible !important;
      }

      .ticketing-donut-v14-holder {
        width: 520px !important;
        height: 350px !important;
        max-width: 100% !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        background: transparent !important;
        border: 0 !important;
        box-shadow: none !important;
        outline: 0 !important;
        padding: 0 !important;
        margin: 0 auto !important;
        overflow: visible !important;
      }

      .ticketing-donut-v14-holder svg {
        width: 520px !important;
        height: 350px !important;
        max-width: 100% !important;
        display: block !important;
        overflow: visible !important;
        background: transparent !important;
        border: 0 !important;
        box-shadow: none !important;
        outline: 0 !important;
      }

      .ticketing-donut-v14-hide-old {
        display: none !important;
      }

      .ticketing-donut-v14-total-label {
        font-size: 13px;
        font-weight: 900;
        fill: #142452;
        text-anchor: middle;
      }

      .ticketing-donut-v14-total-number {
        font-size: 42px;
        font-weight: 1000;
        fill: #142452;
        text-anchor: middle;
      }

      .ticketing-donut-v14-seg-label {
        font-size: 11px;
        font-weight: 900;
        fill: #ffffff;
        text-anchor: middle;
        dominant-baseline: middle;
        paint-order: stroke;
        stroke: rgba(0,0,0,.25);
        stroke-width: 2.4px;
      }

      @keyframes ticketingDonutPulseV15 {
        0% {
          transform: scale(1);
          filter: brightness(1);
        }
        38% {
          transform: scale(1.035);
          filter: brightness(1.13);
        }
        70% {
          transform: scale(1);
          filter: brightness(1);
        }
        100% {
          transform: scale(1);
          filter: brightness(1);
        }
      }

      .ticketing-donut-v15-pulse-segment {
        transform-box: fill-box;
        transform-origin: center;
        animation-name: ticketingDonutPulseV15;
        animation-duration: 2.8s;
        animation-timing-function: ease-in-out;
        animation-iteration-count: infinite;
        will-change: transform, filter;
      }

      @media (prefers-reduced-motion: reduce) {
        .ticketing-donut-v15-pulse-segment {
          animation: none !important;
        }
      }
    `;

    document.head.appendChild(style);
  }

  function emptyCounts() {
    const out = {};

    CATS.forEach((cat) => {
      out[cat.key] = {};
      STATUS_ORDER.forEach((st) => {
        out[cat.key][st] = 0;
      });
    });

    return out;
  }

  function findRekapTable() {
    const tables = Array.from(document.querySelectorAll("table"));

    for (const table of tables) {
      const text = cleanText(table.innerText).toUpperCase();
      const around = cleanText(table.parentElement?.innerText || "").toUpperCase();

      if (
        text.includes("KATEGORI") &&
        text.includes("INF") &&
        text.includes("ERP") &&
        text.includes("APLIKASI") &&
        (text.includes("CLOSED") || text.includes("OVERDUE") || text.includes("REJECTED")) &&
        (around.includes("REKAP STATUS") || text.includes("REJECTED"))
      ) {
        return table;
      }
    }

    return null;
  }

  function readCountsFromRekap() {
    const counts = emptyCounts();
    const table = findRekapTable();

    if (!table) return { found: false, counts, signature: "NO_REKAP" };

    const headers = Array.from(table.querySelectorAll("thead th")).map((h) =>
      cleanText(h.innerText).toUpperCase()
    );

    const colMap = {};
    CATS.forEach((cat) => {
      colMap[cat.key] = headers.findIndex((h) => h.includes(cat.rekap));
    });

    const sig = [];

    Array.from(table.querySelectorAll("tbody tr")).forEach((tr) => {
      const cells = Array.from(tr.cells || []);
      if (!cells.length) return;

      const st = normStatus(cells[0]?.innerText || "");
      if (!st) return;

      CATS.forEach((cat) => {
        const idx = colMap[cat.key];
        if (idx < 0 || !cells[idx]) return;

        const val = parseNumber(cells[idx].innerText);
        counts[cat.key][st] = val;
        sig.push(`${cat.key}:${st}:${val}`);
      });
    });

    return {
      found: true,
      counts,
      signature: sig.join("|"),
    };
  }

  function totalCat(counts, catKey) {
    return STATUS_ORDER.reduce((sum, st) => sum + Number(counts[catKey]?.[st] || 0), 0);
  }

  function findCard(catTitle) {
    const cards = Array.from(document.querySelectorAll("div,section,article"))
      .filter((el) => {
        const txt = cleanText(el.innerText || el.textContent).toUpperCase();
        if (!txt.includes(catTitle)) return false;
        if (txt.includes("REKAP STATUS")) return false;

        const rect = el.getBoundingClientRect();
        if (rect.width < 260 || rect.height < 220) return false;
        if (rect.width > window.innerWidth * 0.68) return false;

        return el.querySelector("canvas,svg") || txt.includes("TOTAL") || txt.includes("TICKET");
      })
      .map((el) => {
        const rect = el.getBoundingClientRect();
        return { el, area: rect.width * rect.height };
      })
      .sort((a, b) => a.area - b.area);

    return cards.length ? cards[0].el : null;
  }

  function clearOldInside(card) {
    if (!card) return;

    card.querySelectorAll(
      ".ticketing-donut-overlay-fix,.ticketing-donut-v4-wrap,.ticketing-donut-v5-wrap,.ticketing-donut-v6-container,.ticketing-donut-v7-chart-area,.ticketing-donut-v8-chart-area,.ticketing-donut-v14-area"
    ).forEach((el) => el.remove());

    card.querySelectorAll(
      ".ticketing-donut-original-hidden-fix,.ticketing-old-chart-v4-hidden,.ticketing-donut-v5-hide-old,.ticketing-donut-v6-hide-old,.ticketing-donut-v7-hide-old,.ticketing-donut-v8-hide-old,.ticketing-donut-v14-hide-old"
    ).forEach((el) => {
      el.classList.remove("ticketing-donut-original-hidden-fix");
      el.classList.remove("ticketing-old-chart-v4-hidden");
      el.classList.remove("ticketing-donut-v5-hide-old");
      el.classList.remove("ticketing-donut-v6-hide-old");
      el.classList.remove("ticketing-donut-v7-hide-old");
      el.classList.remove("ticketing-donut-v8-hide-old");
      el.classList.remove("ticketing-donut-v14-hide-old");
      el.style.opacity = "";
      el.style.visibility = "";
      el.style.display = "";
    });
  }

  function findChartParent(card) {
    const charts = Array.from(card.querySelectorAll("canvas,svg"))
      .filter((el) => !el.closest(".ticketing-donut-v14-area"))
      .filter((el) => {
        const r = el.getBoundingClientRect();
        return r.width > 80 && r.height > 80;
      });

    if (charts.length) {
      const chart = charts[0];
      const parent = chart.parentElement || card;

      charts.forEach((el) => {
        el.classList.add("ticketing-donut-v14-hide-old");
      });

      return parent;
    }

    return card;
  }

  function polar(cx, cy, r, angleDeg) {
    const rad = ((angleDeg - 90) * Math.PI) / 180;
    return {
      x: cx + r * Math.cos(rad),
      y: cy + r * Math.sin(rad),
    };
  }

  function annularPath(cx, cy, outerR, innerR, startAngle, endAngle) {
    const full = Math.abs(endAngle - startAngle) >= 359.5;

    if (full) {
      return `
        M ${cx} ${cy - outerR}
        A ${outerR} ${outerR} 0 1 1 ${cx} ${cy + outerR}
        A ${outerR} ${outerR} 0 1 1 ${cx} ${cy - outerR}
        M ${cx} ${cy - innerR}
        A ${innerR} ${innerR} 0 1 0 ${cx} ${cy + innerR}
        A ${innerR} ${innerR} 0 1 0 ${cx} ${cy - innerR}
        Z
      `;
    }

    const p1 = polar(cx, cy, outerR, startAngle);
    const p2 = polar(cx, cy, outerR, endAngle);
    const p3 = polar(cx, cy, innerR, endAngle);
    const p4 = polar(cx, cy, innerR, startAngle);
    const large = endAngle - startAngle > 180 ? 1 : 0;

    return `
      M ${p1.x.toFixed(2)} ${p1.y.toFixed(2)}
      A ${outerR} ${outerR} 0 ${large} 1 ${p2.x.toFixed(2)} ${p2.y.toFixed(2)}
      L ${p3.x.toFixed(2)} ${p3.y.toFixed(2)}
      A ${innerR} ${innerR} 0 ${large} 0 ${p4.x.toFixed(2)} ${p4.y.toFixed(2)}
      Z
    `;
  }

  function makeSvg(counts, catKey) {
    const total = totalCat(counts, catKey);

    const cx = 260;
    const cy = 175;
    const outerR = 138;
    const innerR = 57;
    const gap = 3.5;

    const items = STATUS_ORDER
      .map((st) => ({
        st,
        label: STATUS_LABEL[st] || st,
        value: Number(counts[catKey]?.[st] || 0),
        color: STATUS_COLOR[st] || "#94a3b8",
      }))
      .filter((x) => x.value > 0);

    if (!items.length) {
      items.push({ st: "NO DATA", label: "No Data", value: 0, color: "#cbd5e1" });
    }

    let angle = 0;
    let paths = "";
    let labels = "";

    items.forEach((item, idx) => {
      const portion = total > 0 ? item.value / total : 1;
      const deg = portion * 360;

      const start = items.length > 1 ? angle + gap / 2 : angle;
      const end = items.length > 1 ? angle + deg - gap / 2 : angle + deg;

      paths += `
        <path
          class="ticketing-donut-v15-pulse-segment"
          style="animation-delay: ${idx * 0.28}s;"
          d="${annularPath(cx, cy, outerR, innerR, start, end)}"
          fill="${item.color}"
          fill-rule="evenodd"
          stroke="#ffffff"
          stroke-width="5"
          stroke-linejoin="round"
        />
      `;

      if (item.value > 0) {
        const mid = start + (end - start) / 2;
        const labelR = (outerR + innerR) / 2 + 2;
        const p = polar(cx, cy, labelR, mid);
        const pct = total > 0 ? Math.round((item.value / total) * 100) : 0;

        labels += `
          <text class="ticketing-donut-v14-seg-label" x="${p.x.toFixed(1)}" y="${(p.y - 7).toFixed(1)}">
            ${item.label.toUpperCase()}
          </text>
          <text class="ticketing-donut-v14-seg-label" x="${p.x.toFixed(1)}" y="${(p.y + 8).toFixed(1)}">
            ${item.value} tiket (${pct}%)
          </text>
        `;
      }

      angle += deg;
    });

    return `
      <svg viewBox="0 0 520 350" role="img" aria-label="${catKey}">
        <defs>
          <filter id="ticketingDonutShadowV14${catKey}">
            <feDropShadow dx="0" dy="8" stdDeviation="8" flood-color="#0f172a" flood-opacity=".16"/>
          </filter>
        </defs>

        <g filter="url(#ticketingDonutShadowV14${catKey})">
          ${paths}
        </g>

        <circle cx="${cx}" cy="${cy}" r="62" fill="#ffffff" stroke="#e5e7eb" stroke-width="4"/>

        <text class="ticketing-donut-v14-total-label" x="${cx}" y="${cy - 25}">TOTAL</text>
        <text class="ticketing-donut-v14-total-number" x="${cx}" y="${cy + 11}">${total}</text>
        <text class="ticketing-donut-v14-total-label" x="${cx}" y="${cy + 39}">TICKET</text>

        ${labels}
      </svg>
    `;
  }

  function renderCat(counts, cat) {
    const card = findCard(cat.title);
    if (!card) return false;

    clearOldInside(card);

    const chartParent = findChartParent(card);
    chartParent.style.background = "transparent";
    chartParent.style.backgroundColor = "transparent";
    chartParent.style.border = "0";
    chartParent.style.boxShadow = "none";
    chartParent.style.outline = "0";
    chartParent.style.overflow = "visible";

    const area = document.createElement("div");
    area.className = "ticketing-donut-v14-area";

    const holder = document.createElement("div");
    holder.className = "ticketing-donut-v14-holder";
    holder.innerHTML = makeSvg(counts, cat.key);

    area.appendChild(holder);
    chartParent.appendChild(area);

    return true;
  }

  function apply(force = false) {
    injectStyle();

    const result = readCountsFromRekap();
    if (!result.found) return;

    if (!force && result.signature === lastSignature) return;
    lastSignature = result.signature;

    const rendered = {};
    CATS.forEach((cat) => {
      rendered[cat.key] = renderCat(result.counts, cat);
    });

    window.__TICKETING_DONUT_PUBLIC_SHAPE_COUNTS_V14__ = result.counts;
    window.__TICKETING_DONUT_PUBLIC_SHAPE_RENDERED_V14__ = rendered;
  }

  function schedule(force = false) {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => apply(force), 260);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => schedule(true));
  } else {
    schedule(true);
  }

  document.addEventListener("click", () => schedule(true), true);
  document.addEventListener("change", () => schedule(true), true);
  document.addEventListener("input", () => schedule(true), true);

  setInterval(() => apply(false), 2500);

  window.__FIX_TICKETING_DONUT_PUBLIC_SHAPE_V14__ = () => apply(true);
})();
